<template>
	<div class="grid gap-4">
		<FormKit
			type="select"
			placeholder="Kies..."
			name="uitkeringType"
			label="Soort uitkering"
			select-icon="down"
			:options="typeOptions"
		/>
		<FormKit type="loanlinkDate" name="startDate" label="Ingangsdatum" />
		<FormKit type="loanlinkDate" name="endDate" label="Einddatum" />
		<FormKit
			type="loanlinkCurrency"
			name="grossYearlyBenefit"
			label="Bruto uitkering per jaar"
		/>
		<FormKit
			type="loanlinkCurrency"
			name="vacationBenefit"
			label="Vakantietoeslag"
		/>
		<FormKit
			type="loanlinkPercentage"
			name="percentageCounted"
			label="Percentage meetellen voor toetsinkomen"
		/>
	</div>
</template>

<script lang="ts" setup>
import type { UitkeringType } from "@loanlink-nl/model-app";
import type { InventarisationSelectOption } from "@/models/inventarisation/InventarisationSelectOption";

const typeOptions: InventarisationSelectOption<UitkeringType>[] = [
	{ label: "ANW", value: "06 ANW" },
	{ label: "AOW", value: "09 AOW" },
	{ label: "Bijstand", value: "02 Bijstand" },
	{ label: "IVA", value: "12 IVA" },
	{ label: "Nabestaandenpensioen", value: "16 Nabestaandenpensioen" },
	{ label: "Ouderdomspensioen", value: "15 Ouderdomspensioen" },
	{ label: "RWW", value: "05 RWW" },
	{ label: "Verzekering", value: "07 Verzekering" },
	{ label: "Wachtgeld", value: "04 Wachtgeld" },
	{ label: "Wajong", value: "08 Wajong" },
	{ label: "WAZ", value: "10 WAZ" },
	{ label: "WAO met herkeuring", value: "13 WAO met herkeuring" },
	{ label: "WAO zonder herkeuring", value: "14 WAO zonder herkeuring" },
	{ label: "WGA", value: "11 WGA" },
	{ label: "WW", value: "03 WW" },
];
</script>
